import './public-path'
import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import API from './api'
import i18n from './locale';
import microApps from './util/microApps'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/app.styl'
import './assets/css/agent/agent.styl'
import './assets/css/default.styl'
import './assets/iconfont/iconfont.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import './assets/icons/index'
import svgIcon from './components/svg'


Vue.component('svg-icon',svgIcon)

Vue.config.productionTip = false;
Vue.prototype.$api = API

const BrowserLogger = require('alife-logger')
// BrowserLogger.singleton(conf) conf传入config配置。
// eslint-disable-next-line no-unused-vars
const bl = BrowserLogger.singleton({
  pid: 'g2t7afypx3@88218cd03a04623',
  // 设定日志上传地址：
  // 部署新加坡地域可设为`https://arms-retcode-sg.aliyuncs.com/r.png?`。
  // 部署美西地域可设为`http://arms-us-west-1.console.aliyun.com/r.png?`。
  imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
  // enableLinkTrace:true,
  // enableApiCors: true,
  // 其他config配置。
});
Vue.use(ElementUI,{ locale });
new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

microApps({ store, router, $appData: {}, Vue })
